/* eslint-disable import/prefer-default-export */

import {
  GET_USER_REGISTER_DATA,
  REGISTER_USER,
  RESET_PASSWORD,
  SAVE_PASSWORD,
} from '../constants';
import http from '../core/HttpClient';
import urls from '../constants/urls';

export function getRegisterData() {
  return {
    type: GET_USER_REGISTER_DATA,
    promise: http.get(`${urls.API_USERS}/register`),
  };
}

export function registerUser(data) {
  return {
    type: REGISTER_USER,
    promise: http.post(`${urls.API_USERS}/register`, data),
  };
}

export function resetPassword(data) {
  return {
    type: RESET_PASSWORD,
    promise: http.post('/recoverPassword', data),
  };
}

export function saveNewPassword(password) {
  return {
    type: SAVE_PASSWORD,
    promise: http.post('/savePassword', { password }),
  };
}



// WEBPACK FOOTER //
// ./src/actions/login.js